import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

const NeighborhoodWithCheckboxContainer = styled.div`
  align-items: center;
  display: flex;
  margin-left: ${props => (props.shouldIndent ? "10px" : "0")};
`;

const fontSizeDetector = (isTitle, nameLength, showCheckBox) => {
  let fontSize;

  if (isTitle) {
    fontSize = nameLength >= 10 && showCheckBox ? "8px" : "11px";
  } else {
    fontSize = "14px";
  }

  return fontSize;
};

const NeighborhoodTitle = styled(Text).attrs({ type: "sm" })`
  background-color: ${props =>
    props.isHovered ? colorPalette.secondary : "none"};
  font-weight: ${props => (props.isTitle ? "bold" : "normal")};
  font-size: ${props =>
    fontSizeDetector(props.isTitle, props.nameLength, props.showCheckBox)};
  text-transform: ${props => (props.isTitle ? "uppercase" : "none")};
  margin-left: 5px;
`;

NeighborhoodWithCheckboxContainer.displayName =
  "NeighborhoodWithCheckboxContainer";
NeighborhoodTitle.displayName = "NeighborhoodTitle";

export { NeighborhoodWithCheckboxContainer, NeighborhoodTitle };
